"use client";

import { without } from "lodash-es";

import { CompanyIcon, LabelIcon } from "@/components/appIcons";

import { FilterChip } from "./filter-chip";

export function SearchOrganizationFilterChips({
  labels,
  companies,
  setFilter,
}: {
  labels: string[];
  companies: string[];
  setFilter: (key: "label" | "company", value: string[] | undefined) => void;
}) {
  return (
    <>
      {labels.map((label) => (
        <FilterChip
          key={label}
          icon={LabelIcon}
          onClear={() => {
            const next = without(labels, label);
            setFilter("label", next.length ? next : undefined);
          }}
        >
          {label}
        </FilterChip>
      ))}
      {companies.map((company) => (
        <FilterChip
          key={company}
          icon={CompanyIcon}
          onClear={() => {
            const next = without(companies, company);
            setFilter("company", next.length ? next : undefined);
          }}
        >
          {company}
        </FilterChip>
      ))}
    </>
  );
}
